import React from 'react';

import CountryMap from 'components/Map/CountryMap/CountryMap';
import AddressMap from 'components/Map/AddressMap/AddressMap';

import {
  marker,
  addressClusters,
  countryOrders,
  countryClusters,
  iconSet
} from './clustersAndOrders';

import {
  Layout,
  Row,
  Title,
  Label,
  ListElement,
  MapTooltipPoints,
  MapTooltipIcons
  } from 'elements/Tooltip/Layout';

const renderCountryMapTooltip = () => (
  <Layout>
     <Row>
      <Label inline>ITFS LINE 2</Label>
      <MapTooltipIcons icons={iconSet} />
    </Row>
    <Row spaceBetween>
      <MapTooltipPoints from="Portugal" to="India" />
    </Row>
  </Layout>
);

const renderAddressMapTooltip = (lat, lng) => (
  <Layout>
    <Row>
      <Title>Braga</Title>
    </Row>
    <Row spaceBetween>
      <Label inline>LAT</Label>
      <Label inline>LONG</Label>
    </Row>
    <Row>
      <ListElement>
        {lat}
      </ListElement>
      <ListElement>
        {lng}
      </ListElement>
    </Row>
  </Layout>
);


export const pinLayout = () => (
  <AddressMap
    center={{ lat: 41.549402, lng: -8.422407 }}
    marker={marker}
    withLegend
    tooltipContent={renderAddressMapTooltip}
  />
);

export const popAndLegendLayout = () => (
  <AddressMap
    center={{ lat: 41.549402, lng: -8.422407 }}
    marker={marker}
    clusters={addressClusters}
    withLegend
    tooltipContent={renderAddressMapTooltip}
  />
);

export const clusterAndLegendLayout = () => (
  <CountryMap
    center={{ lat: 52.076604, lng: -0.522302 }}
    zoom={5}
    clusters={countryClusters}
    withLegend
  />
);

export const orderLinesLayout = () => (
  <CountryMap
    center={{ lat: 38.505504, lng: 30.638125 }}
    orders={countryOrders}
    tooltipContent={renderCountryMapTooltip()}
  />
);




// WEBPACK FOOTER //
// ./src/containers/components/Map/constants/mapsLayouts.js